import { render, staticRenderFns } from "./DefaultLandingPage.vue?vue&type=template&id=7e33b433"
import script from "./DefaultLandingPage.vue?vue&type=script&lang=js"
export * from "./DefaultLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports